import axios from "axios";
import LoginPage from "../pages/login";

const AUTH_TOKEN_KEY = "@AUTH_TOKEN";
const USER_ID_KEY = "@USER_ID";
const USER_EMAIL_KEY = "@USER_EMAIL";
const USER_FIRST_NAME_KEY = "@USER_FIRST_NAME";
const USER_LAST_NAME_KEY = "@USER_LAST_NAME";

export default class {
  constructor() {
    const baseURL = this._getBaseURL();
    const apiURL = this._getApiURL();
    const russianRootURL = this._getRussianRootURL();
    this.authURL = `${baseURL}/${apiURL}/auth/api-token-auth/`;
    this.refreshURL = `${baseURL}/${apiURL}/auth/api-token-refresh/`;
    this.verifyURL = `${baseURL}/${apiURL}/auth/api-token-verify/`;
  }

  async auth(payload) {
    const response = await axios.post(this.authURL, payload);
    const token = response.data.token;
    this.setToken(token);
    return token;
  }

  async getMe() {
    const meURL = `/me/`;
    const response = await this.doGet(meURL);
    const data = response.data;

    localStorage.setItem(USER_ID_KEY, data.id);
    localStorage.setItem(USER_EMAIL_KEY, data.email);
    localStorage.setItem(USER_FIRST_NAME_KEY, data.first_name);
    localStorage.setItem(USER_LAST_NAME_KEY, data.last_name);

    return data;
  }

  getUserInfo() {
    if (process.browser) {
      return {
        id: localStorage.getItem(USER_ID_KEY),
        email: localStorage.getItem(USER_EMAIL_KEY),
        firstName: localStorage.getItem(USER_FIRST_NAME_KEY),
        lastName: localStorage.getItem(USER_LAST_NAME_KEY),
      };
    }
    return {};
  }

  verify(token) {
    return axios.post(this.verifyURL, { token });
  }

  setToken(token) {
    return localStorage.setItem(AUTH_TOKEN_KEY, token);
  }

  getToken() {
    return localStorage.getItem(AUTH_TOKEN_KEY);
  }

  deleteToken() {
    return localStorage.removeItem(AUTH_TOKEN_KEY);
  }

  // localStorageTokenIsValid() {
  //   const token = this.getToken();
  //   return this.verify(token);
  // }

  async doGet(url, params, tokenOverride) {
    const axios = await this.initializeAxiosInstance(tokenOverride);
    const response = await axios.get(url, { params });
    return response;
  }

  async doPut(url, payload, tokenOverride) {
    const axios = await this.initializeAxiosInstance(tokenOverride);
    const response = await axios.put(url, payload);
    return response;
  }

  async doPatch(url, payload, tokenOverride, useProxy = false) {
    const axios = await this.initializeAxiosInstance(tokenOverride, useProxy);
    const response = await axios.patch(url, payload);
    return response;
  }

  async doPost(url, payload, tokenOverride) {
    const axios = await this.initializeAxiosInstance(tokenOverride);
    const response = await axios.post(url, payload);
    return response;
  }

  async doDelete(url, tokenOverride) {
    const axios = await this.initializeAxiosInstance(tokenOverride);
    const response = await axios.delete(url);
    return response;
  }

  createBaseAPIUrl(uri, useProxy = false) {
    return `${this.getBaseURLProxy(useProxy)}/${this._getApiURL()}${uri}`;
  }

  getBaseURLProxy(useProxy = false) {
    if (useProxy) {
      return this._getRussianRootURL();
    } else {
      return this._getBaseURL();
    }
  }

  async initializeAxiosInstance(tokenOverride, useProxy = false) {
    // if (
    //   this._instance &&
    //   this._instance.defaults.headers.common["Authorization"]
    // ) {
    //   this._instance = axios.create({
    //     baseURL: `${this.getBaseURLProxy(useProxy)}/${this._getApiURL()}`
    //   });
    //   return this._instance;
    // }

    this._instance = axios.create({
      baseURL: `${this.getBaseURLProxy(useProxy)}/${this._getApiURL()}`,
    });

    if (process.browser) {
      let token = tokenOverride ? tokenOverride : this.getToken();
      if (token) {
        try {
          const validTokenResponse = await this.verify(token);
          token = validTokenResponse?.data?.token;
          this._instance.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${token}`;
        } catch (error) {}
      }
    }

    return this._instance;
  }

  arrayToObject(array) {
    return array.reduce((obj, item) => {
      obj[item.id] = item;
      return obj;
    }, {});
  }

  _getRussianRootURL() {
    return process.env.NEXT_PUBLIC_RUSSIAN_ROOT_URL;
  }

  _getBaseURL() {
    // return "http://yoshi.willandskill.eu:8444";
    // return "https://stage.vvenues.com";
    // return "https://admin.vvenues.com";
    return process.env.NEXT_PUBLIC_ROOT_URL;
  }

  _getApiURL() {
    return "api/v1";
  }
}
